import React, { useEffect } from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';
import { UserArea } from '@components/molecules/UserArea';
import styles from './MyProfile.module.css';
import { useData } from '@hooks/useData';
import { Loader } from '@components/atoms/Loader';
import { SITE_URLS } from '@constants';
import { useNavigate } from 'react-router-dom';
import { useGetUser } from '@services/useGetUser';

export function MyProfile() {
    const { user, login } = useData();
    const { request: requestUser, loading } = useGetUser();
    const navigate = useNavigate();

    useEffect(() => {
        requestUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Fetch on mount

    useEffect(() => {
        if (user === null && !login) {
            navigate(`/${SITE_URLS.login}`);
        }
    }, [user, navigate, login]);

    return (
        <MobileContainer>
            {!user || loading ? (
                <div className={styles.loader}>
                    <Loader />
                </div>
            ) : (
                <UserArea userData={user.data} />
            )}
        </MobileContainer>
    );
}
